// Pure decision functions extracted from fitWidth.jsx (Fase 1 P1, bloco
// render-core). The class methods (handleWindowResize / handleContainerResize /
// measureParent) read `document` and `this.state` and then branch on the result;
// the BRANCH arithmetic moved here so it can be unit-tested without jsdom
// (vitest runs in the node environment). The class imports and delegates — the
// DOM reads stay inline, only the boolean decisions are extracted.
//
// Serves Directive 8 (visual feedback never stalls / fitWidth não destrói o
// tree indevidamente).

// --- D8 ----------------------------------------------------------------
// The destructive 0→recalculate cycle UNMOUNTS the entire chart tree. A handful
// of UI sources (favorites sidebar toggle, objects-sidebar view-mode switches)
// fire a resize whose layout already settled, so the destructive cycle is pure
// churn — bypass it and re-measure directly. Whitelist ONLY these three; every
// other source (window-resize, etc.) keeps the destructive cycle.
export function shouldBypassDestructiveCycle(source) {
  return (
    source === "sidebar-favorites.toggle.delayed-0ms" ||
    source === "objects-sidebar.view-mode.grid.delayed-100ms" ||
    source === "objects-sidebar.view-mode.list.delayed-100ms"
  );
}

// --- D8 ----------------------------------------------------------------
// When a PrimeReact overlay (dialog mask or context menu) is open, the
// destructive 0→recalculate cycle would unmount the chart tree and destroy the
// open overlay (mobile keyboard resize symptom). Skip it and measure directly —
// but ONLY when we already have a valid size (width>0 && height>0); on the
// first measurement there is nothing to preserve, so the normal path runs.
export function shouldBypassForOverlay(stateWidth, stateHeight, hasOverlay) {
  return !!(stateWidth > 0 && stateHeight > 0 && hasOverlay);
}

// --- D8 ----------------------------------------------------------------
// measureParent must NEVER apply a non-positive dimension (a transient 0×0 from
// a FlexLayout transition would collapse the chart). Both axes must be strictly
// positive for the measurement to be valid.
export function isValidMeasuredDimension(w, h) {
  return w > 0 && h > 0;
}

// --- D8 ----------------------------------------------------------------
// handleContainerResize only does work when the measured size actually differs
// from the committed state size — otherwise a ResizeObserver callback for an
// unchanged box would trigger a needless setState/redraw.
export function containerDimensionsChanged(w, h, stateWidth, stateHeight) {
  return w !== stateWidth || h !== stateHeight;
}
